import {PAISESINDICATIVO} from "../Recursos/indicativos";

export const obtenerIndicativo = (pais) =>{

    let index = PAISESINDICATIVO.findIndex((it) => it.nameES === pais)
    return PAISESINDICATIVO[index].phoneCode

}